$(document).on('change', '.product-variant-selection', function () {
    let selected = $('option:selected', this).val();
    if (selected.startsWith('http') || selected.startsWith('/')) {
        window.location.href = selected;
        return true;
    }
    // call variant api
    let url = window.config.urls.products.info.replace(':product:', selected);
    window.axios.get(url)
        .then((response) => {
            // success
            let container = $('#product-variants-action');
            if (container.length === 0) {
                container = $(this).closest('.is-card');
            }
            if (container.length > 0) {
                let buy = response.data.actions.buy, compare = response.data.actions.compare, favorite = response.data.actions.favorite;
                $('[data-product-id]', container).data('product-id', response.data.product.id);
                $('.add-to-cart', container).toggleClass('d-none', !buy).data('product-id', response.data.product.id);
                $('.add-to-cart', container).parent().toggleClass('d-none', !buy);
                $('.is-counter', container).toggleClass('d-none', !buy);
                $('#product-variants-action > div:last-child', container).toggleClass('mt-3', buy);
                $('.add-to-list', container).toggleClass('d-none', !favorite);
                $('.add-to-compare', container).toggleClass('d-none', !compare);
                container.removeClass('d-none');
            }
            if (response.data.price) {
                $('[aria-label="product price"],.is-card:actions:prices > span', container).html(response.data.price.formatted);
            }
            if ('availability' in response.data) {
                $('[aria-label="product availability"]', container).html(response.data.availability);
                $('[aria-label="product availability"]', container).toggleClass('mb-3', response.data.availability !== '');
            }
            if (response.data.uri) {
                $('.is-card-cta', container).attr('href', response.data.uri);
            }
            if (response.data.quantitySelect) {
                $('.product-variant-quantity', container).html(response.data.quantitySelect);
            }
        })
        .catch((error) => {
            // error
            $('#product-variants-action').addClass('d-none');
        });
});
